import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { Subject, debounceTime, filter } from 'rxjs';
import { MedicationsService } from 'src/app/shared/services/medications/medications.service';

@Component({
  selector: 'app-search-medications-in-use',
  templateUrl: './search-medications.component.html',
  styleUrls: ['./search-medications.component.scss']
})
export class SearchMedicationsComponent {

  @Output() medication = new EventEmitter();
  @Input() medShow: string = '';
  @Input() searchTerm$ = new Subject<string>();

  medicationsSearched: any[] = [];
  searchingMedications: boolean = false;

  constructor(private medicationsService: MedicationsService,
    private elementRef: ElementRef) {

    this.searchTerm$
      .pipe(
        debounceTime(500),
        filter(x => x.length > 2)
      )
      .subscribe(searchObj => {

        this.searchingMedications = true;
        this.medicationsService.getMedications(searchObj)
          .then((res: any) => {

            if (res&& res.data && res.data.length > 0) {

              this.medicationsSearched = [];
              this.medicationsSearched = res.data;
            }
          })
          .finally(() => {

            this.searchingMedications = false;
          })
      });
  }

  onSearchTermChange(term: string): void {

    this.searchTerm$.next(term);
  }

  selectMedication(itemSelected: any) {

    this.medShow = itemSelected.description;
    this.medication.emit(this.medShow);
    this.medicationsSearched = [];
  }

  changeColor(item: any) {

    item.backgroundColor = '#f2f2f2';
  }

  resetColor(item: any) {

    item.backgroundColor = '';
  }

  @HostListener('document:click', ['$event'])
  checkClick(event: MouseEvent) {

    if (!this.elementRef.nativeElement.contains(event.target)) {

      this.medicationsSearched = [];
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    if (event.key === 'Backspace' || event.key === 'Delete') {

      this.medicationsSearched = [];
    }
  }

}
